module.exports = __webpack_public_path__ + "img/platform_5.svg";